/*
 * @Author: fan.lion@foxmail.com
 * @Date: 2020-02-11 16:44:07
 * @Last Modified by: fan.lion@foxmail.com
 * @Last Modified time: 2020-02-18 14:55:22
 *
 * 周菜谱 module
 */

import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const Main = Loadable({
	loader: () => import('./main'),
	loading: Spin,
});

export default ({ match }) => (
	<Switch>
	  <Route path={match.url} component={Main} />
	</Switch>
);
